import { Center, Text } from '@mantine/core';
import type { ReactNode } from 'react';

/** Why the review's record pane has nothing to draw, in one centred line. */
export const ReviewEmpty = ({ children }: { children: ReactNode }) => (
    <Center py={48} px="md">
        <Text fz="sm" c="dimmed" ta="center">
            {children}
        </Text>
    </Center>
);
